import { observer } from "mobx-react-lite";

import { FractionNode } from "@/components/expression/FractionNode";
import { PostfixOperatorNode } from "@/components/expression/PostfixOperatorNode";
import { PrefixOperatorNode } from "@/components/expression/PrefixOperatorNode";
import { SquareRoot } from "@/components/expression/SquareRoot";
import { OperatorType } from "@/models/nodes/operators";
import { isSupSubNode } from "@/models/utils/semanticChecks";

import type { ExpressionComponent } from "./types";

export const OperatorNode: ExpressionComponent<"operator"> = observer(function OperatorNode({
  node,
  ...props
}) {
  if (isSupSubNode(node)) {
    return null;
  }

  if (node.operatorType === OperatorType.FRACTION) {
    return <FractionNode node={node} {...props} />;
  }

  if (node.operatorType === OperatorType.ROOT && node.renderView === "root") {
    return <SquareRoot node={node} {...props} />;
  }

  if (node.placement === "prefix") {
    return <PrefixOperatorNode node={node} {...props} />;
  }

  if (node.placement === "postfix") {
    return <PostfixOperatorNode node={node} {...props} />;
  }
});
